import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default {
  modules: {},
  state: {
    balance: 0,
    discount: 0
  },
  getters: {
    getBalance: (state) => {
      return state.balance
    },
    getDiscount: (state) => {
      return state.discount
    }
  },
  mutations: {
    setBalance(state, payload) {
      state.balance = payload;
    },
    setDiscount(state, payload) {
      state.discount = payload;
    },
  },
  actions: {},
};
